import LineMobileAndroidIcon from 'LuxKit/Icons/line/LineMobileAndroidIcon'
import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import { useIntl } from 'react-intl'

function BedbankMobileOnlyPriceLabel() {
  const intl = useIntl()
  return <PromotionLabel icon={<LineMobileAndroidIcon />}>
    {intl.formatMessage({
      id: 'ciwtuF4FtscTFQMglpH3',
      defaultMessage: 'Mobile only price',
    })}
  </PromotionLabel>
}

export default BedbankMobileOnlyPriceLabel
